<template>
  <div class="other_operate_modal" >
     
    <Modal    
          v-model="otherModal"
          :title="`【${houseDetail['房屋地址']}】业务操作`" 
            :width="screenWidth*0.8"
          @on-cancel="cancel">
          <div class="base-modal" v-if="otherModal">
       
            <div class="illustrate">  
              <Button type="primary" icon="ios-archive-outline" @click="changeIllustrate('修改附件')" :disabled="illustrate.name=='修改附件'">修改附件</Button>
              <Button type="primary" icon="ios-close-circle-outline" @click="changeIllustrate('修改实际付款信息')" :disabled="illustrate.name=='修改实际付款信息'">修改实际付款信息</Button>
   
            </div>
            
            <Alert> 当前业务【{{ illustrate.name }}】 说明：{{ illustrate.content }}</Alert> 
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='修改附件'">  
              <Alert>产证信息</Alert>   
              
              <Upload :action="uploadUrl"  
              :headers="{ 'Authorization': 'Bearer ' +token }"
              accept=".jpg,.jpeg,.png,.pdf"
              :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '产证信息')" 
              :show-upload-list="true" 
              max-size="100*1024" >
            <Button type="info" style="margin-left:20px;">新增附件</Button>
              </Upload>
          <Table border :columns="fjColums" :data="czImgList" :max-height="400">

            <template #img="{ row, index } " >
                <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                  
                  <img style="width:200px;height:200px;" :src="row.img" alt="">
                </div>
                <div v-else>仅支持图片预览</div>
              </template> 
              <template #action="{ row, index } " >
                <div class="buttomGroup">
                  <div class="btn ck" @click="watchFile(row,'产证信息')">查看</div>
                  <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'产证信息')">下载</div> 
                  <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'产证信息')">删除</div>
                </div>
              </template> 
            </Table>

            <Alert>身份证信息</Alert>   
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '身份证信息')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="sfzImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'身份证信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'身份证信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'身份证信息')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>房屋托管合同信息</Alert>   

            <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋托管合同信息')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="fwtghtImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'房屋托管合同信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'房屋托管合同信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'房屋托管合同信息')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>房屋原貌</Alert>   
            <div style="width:100%;display: flex; gap:20px;">
              <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','客厅照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增客厅附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','厨房照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增厨房附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','卫生间照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增卫生间附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','卧室照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增卧室附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','其他照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增其他房间附件</Button>
                </Upload>
              </div>

            
                
              <Table border :columns="fjColums_v2" :data="fwImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'房屋原貌')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'房屋原貌')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'房屋原貌')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>授权委托书</Alert>   

            <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '授权委托书')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="sqhtsImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'授权委托书')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'授权委托书')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'授权委托书')">删除</div>
                    </div>
                  </template> 
                </Table>


              
            </VuePerfectScrollbar>
       
             <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='修改实际付款信息'"> 
             <div class="base-modal-line">
              <div class="item_1"> <div class="item_1-title">当前实际付款时间</div> <div class="item_1-value">{{ currentData['实际付款时间'] }}</div></div>
              <div class="item_1"> <div class="item_1-title">当前实际付款金额</div> <div class="item_1-value">{{ currentData['实际付款金额'] }}</div></div>
             </div>
            
                 <Form :model="sjfk" ref="sjfk" :label-width="150" :rules="ruleValidate"  style="margin-top:20px;">
                 
                 <Row>
                <Col span="12">
                  <FormItem label="实际付款时间" prop="sjfksj" >
                    <DatePicker clearable format="yyyy-MM-dd"  type="date" placement="bottom-end" placeholder="请选择时间范围" style="width: 300px" @on-change="changeDate" />
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="实际付款金额" >
                      <InputNumber clearable  v-model="sjfk.sjfkje"  placeholder="请输入..." style="width: 300px" />
                  </FormItem>
                </Col> 
                
              </Row>
              <Alert>付款凭证</Alert>
              <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList,currentData.id,'1_收房付款计划', '付款凭证',null,null)" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>
              <Table border :columns="fjColums" :data="sjfjpzList" :max-height="600">

                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'付款凭证')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'付款凭证')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'付款凭证')">删除</div>
                    </div>
                  </template> 
                </Table>
             

             
                 </Form>
                 <Row> 
                <Col span="20">   </Col>
                <Col span="4"><Button type="info"  @click="changeSjfk('sjfk')" style="width:200px;" :disabled="sjfk.sjfkje<=0">提交</Button>  </Col>
              </Row>
             </VuePerfectScrollbar>
       


         
            
          
          </div>
          <template #footer>
                <div></div> 
            </template>
    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import RecursiveRenderer from '../line/line.vue';
import otherInfo from './components/other_info.vue'
import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx"; 
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {utilTools} from "@/utils/js/utilTools.js" 
import {fileMethod} from "@/api/files/fileMethod";
 import {userMethod}  from "@/api/login/user"
export default { 
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar,RecursiveRenderer,otherInfo},
  props:{
    houseDetail:{
      type:Object,
      default:{},
    },
    currentData:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          otherModal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant","data_field_map","_index","_rowKey","create_user",],
          illustrate:  {} ,//按钮说明
          //  {name:"补充信息",content:"补充其他信息。"}
          illustrateList:[
            {name:"修改附件",content:"修改房源的附件信息，如房源照片，身份证信息，房屋托管合同信息，产证信息，委托授权书等（旧系统附件暂不支持删除）"},
            {name:"修改实际付款信息",content:"修改实际付款时间，实际付款金额，付款凭证等信息"},
          ],
          // 照片表格
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 房间照片表格
          fjColums_v2:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '房间', key: 'type_2', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 空置
          kzColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '房源地址', key: '房源地址', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '空置天数', key: '空置天数', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
            // 出租
            cczColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '合同编号', key: '合同编号', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '出房租金（元/月）', key: '出房租金', align: 'center'},
            {title: '业务状态', key: '业务状态', align: 'center'},
            {title: '出房人', key: '出房人', align: 'center'},
            {title: '出房门店', key: '出房门店', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
          houseDetailShow:{},
          czImgList:[],//
          sfzImgList:[],
          fwtghtImgList:[],
          sqhtsImgList:[],
          fwImgList:[],

          // ktImgList:[],
          // cfImgList:[],
          // wsImgList:[],
          // wsjImgList:[],
          // qtImgList:[],
          //更换收房人
          ghsfr:{
            sfmd:"",//收房门店
            sfr:"",//收房人
          },
          sfrList:[],//收房人列表
          sfrRuleValidate:{//收房人验证
            // sfmd: [ { required: true, message: '收房门店不能为空', trigger: 'change' }  ],
            // sfr: [ { required: true, message: '收房人不能为空', trigger: 'change' } ],
                 
          },
         
           
          shfjList:[],
          recordList:[],//存储空置记录/出租记录
          detailRecord:{},//当前详情
          kzKey:["房源地址",'状态','状态','租房价格','操作时间','合同起始日','合同到期日','空置天数','操作人',],//详情的key
          czKey:["租客姓名","联系电话","开户行","银行卡号","出房人","出房门店","成交差价（元/月）","成交周期（天）","出房渠道","合同编号","合同起始日",
          "合同到期日","出房费用（元）","出房押金（元）","水电气押金","出房租金（元/月）","租金支付周期","物业/宽带费","物业/宽带费支付周期","违约收入","特别约定"],//详情的key
          ccjlSfzList:[],
          ccjlHtList:[],
          storeUserList:[],//门店用户
          // 实际付款相关参数
          sjfk:{
            sjfksj:"",
            sjfkje:0,
          },
          sjfjpzList:[],//实际付款附件凭证
          ruleValidate:{//实际付款验证
            sjfksj: [ { required: true, message: '实际付款时间不能为空', trigger: 'blur' }  ],
            // sjfkje: [ { required: true, message: '实际付款金额不能为空', trigger: 'blur' } ],
                 
          },
        }
    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      

  
    },
    created(){  
    


    },
   
    watch:{},
    methods:{
      changeIllustrate(name){
        this.illustrate=this.illustrateList.find((i)=>{return i.name===name})
        if(name==="修改附件"){
          // this.cleanPhotoList_fw("客厅照片")
          // this.cleanPhotoList_fw("卧室照片")
          // this.cleanPhotoList_fw("厨房照片")
          // this.cleanPhotoList_fw("卫生间照片")
          // this.cleanPhotoList_fw("其他照片")
          console.log("修改附件")
      
          // this.cleanPhotoListV2("房屋原貌")
          this.multipleCleanPhotoList(["客厅照片","卧室照片","厨房照片","卫生间照片","其他照片"],"房屋原貌")
          this.cleanPhotoListV2("房屋托管合同信息")
          this.cleanPhotoListV2("产证信息")
          this.cleanPhotoListV2("身份证信息")
          this.cleanPhotoListV2("授权委托书")
        }
        else if(name==="修改实际付款信息"){
          this.cleanPhotoListV3("付款凭证","1_收房付款计划",this.currentData.id,"付款凭证",null,this.currentData)
         
        }
       

      },
      getPhotoOnlyShow(data,oldSystemKey,father_table,father_id,type1,type2,showDataName){
        console.log("data===",data)
        console.log("data[oldSystemKey]===",data[oldSystemKey])
        let imgList = []
        if(data[oldSystemKey]!=null&&data[oldSystemKey]!=undefined){
          let oldImgList=JSON.parse(data[oldSystemKey])
          oldImgList.forEach((i)=>{
            imgList.push(this.imgBaseUrl+i.fileAddress)
          })
        }
        let params={
          father_table:father_table,
          father_id:father_id,
          type_1:type1,
          type_2:type2
        }
        fileMethod.selectFiles(params).then((res)=>{
          res.data.selectRes.forEach((i)=>{
            imgList.push("/xjby/view/"+i.show_path)
          })
          console.log("imgList==",imgList)
          this[showDataName] = imgList;
        })
    
         

      },
      // 获取门店用户
      initStoreUser(){
        userMethod.getStoresUser().then((res)=>{
          this.storeUserList=res.data
        })
      },
      // 过滤门店用户
      filterStoreUser(name){
        console.log("name===",name)
        if(name){
          this.sfrList= this.storeUserList.filter(item => item['所属门店'] === name);
        }else{
          this.sfrList=[]
        }
         
      },
      cleanData(obj, properties) { 
        // console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
      // 实际付款金额
      changeSjfk(name){
        this.$refs[name].validate((valid) => {
          console.log("this.ghsfr==",this.ghsfr)
         if (valid) {
            let _this=this
            _this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                let param={ }
                param.id=_this.currentData.id
                 param.sjfksj=_this.sjfk.sjfksj
                 param.sjfkje=_this.sjfk.sjfkje
                zfglMethod_2_001.changeSjfk(param).then((res)=>{
                  console.log("修改实际付款====",res)
                  if(res.data.updateRes){
                    _this.$Message.success("修改成功")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }else{
                    _this.$Message.error("修改失败（请联系管理员）")
                  }
                })


              }})
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
      },

      
      // 新版清洗照片（新旧系统一起获取）
      cleanPhotoListV2(key){
        let data= []
        //  新系统
        zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key,}).then((res)=>{
          console.log(key,"--查询结果--",res)
          res.data.list.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
        })
        // 旧系统
        if(this.houseDetail.data_field_map==null||this.houseDetail.data_field_map==''||this.houseDetail.data_field_map==undefined){
          this.saveImage(key,data)
        }else{
          let data_field_map=JSON.parse(this.houseDetail.data_field_map)
          if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
            this.saveImage(key,data)
          }
          else{
            data_field_map[key].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:key,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            this.saveImage(key,data)
          }
        }
       
         
      },
      // 新版清洗照片（新旧系统一起获取）（非房源版本）
      cleanPhotoListV3(key,father_table,father_id,type_1,type_2,old_data){
        let data= []
        //  新系统
        fileMethod.selectFiles({father_table:father_table,father_id:father_id,type_1:type_1,type_2:type_2}).then((res)=>{
          console.log(key,"--查询结果--",res)
         if(res.data.selectRes){
          res.data.selectRes.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
         } 
        })
        // 旧系统
        if(old_data.data_field_map==null||old_data.data_field_map==''||old_data.data_field_map==undefined){
          this.saveImage(key,data)
        }else{
          let data_field_map=JSON.parse(old_data.data_field_map)
          if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
            this.saveImage(key,data)
          }
          else{
            data_field_map[key].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:key,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            this.saveImage(key,data)
          }
        }
       
         
      },
       // 新版清洗照片--房间照片专属(批量)（新旧系统一起获取）
       multipleCleanPhotoList(key,dataName){
        let data= []
        key.forEach((itemKey)=>{
        //  新系统
        zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:itemKey,}).then((res)=>{
          console.log(key,"--查询结果--",res)
          res.data.list.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
        })
        // 旧系统
        if(this.houseDetail.data_field_map==null||this.houseDetail.data_field_map==''||this.houseDetail.data_field_map==undefined){
          return;
        }else{
          let data_field_map=JSON.parse(this.houseDetail.data_field_map)
          if (data_field_map[itemKey]==""||data_field_map[itemKey]==null||data_field_map[itemKey]== undefined) {
            return;
          }
          else{
            data_field_map[itemKey].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:itemKey,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            
          }
        }
        }) 
        this.saveImage(dataName,data)
         
      },
      // 清洗照片
         cleanPhotoList(key){ 
        
            let data = this.houseDetail[key];
            zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key,}).then((res)=>{
              console.log(key,"--查询结果--",res)
              let data = res.data
              this.getPhotoList_newSystem(key,data)
            }) 
    
            let data_field_map=JSON.parse(this.houseDetail.data_field_map)
            if(key=="房屋原貌"){
              let data=[] 
              console.log("卧室照片===",data_field_map["卧室照片"])
              console.log("客厅照片===",data_field_map["客厅照片"])
              console.log("厨房照片===",data_field_map["厨房照片"])
              console.log("卫生间照片===",data_field_map["卫生间照片"])
              let data_ws=JSON.parse(data_field_map["卧室照片"])
     
              let data_kt=JSON.parse(data_field_map["客厅照片"])
              let data_cf=JSON.parse(data_field_map["厨房照片"])
              let data_wsj=JSON.parse(data_field_map["卫生间照片"])
              data_ws.forEach((i)=>{data.push(i)})
              data_kt.forEach((i)=>{data.push(i)})
              data_cf.forEach((i)=>{data.push(i)})
              data_wsj.forEach((i)=>{data.push(i)}) 
              this.getPhotoList_oldSystem(key,data)
            }
            else{
              let data_field_map=JSON.parse(this.houseDetail.data_field_map)
              if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
              this.saveImage(key,[])
            } else{
              let data = JSON.parse(data_field_map[key]);
                  if (data.length === 0) {
                    this.saveImage(key,[])
                  }
                  this.getPhotoList_oldSystem(key,data)
            }
            }
           
          
         },
        //房屋照片特例
       async   cleanPhotoList_fw(key) {
          if (this.houseDetail.source === "new_system") {
            try {
              const res = await zfglMethod_2_001.getHousePhotosById({ id: this.houseDetail.id, type_1: "房屋原貌", type_2: key });
              console.log("图片详情res===", res.data.list);
              
              let imgList = [];
              if (res.data && res.data.list.length > 0) {
                res.data.list.forEach((i) => {
                  let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
                });
              }
              console.log("imgList===", imgList);
              this.saveImage(key,imgList)
              
            } catch (error) {
              this.saveImage(key,imgList)
            }
          } else {
            if (!this.houseDetail['房屋原貌']) {
              this.saveImage(key,[])
            }

            let data = JSON.parse(this.houseDetail['房屋原貌']);
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return this.getPhotoList_oldSystem(key, data);
          }
        },

//旧系统获取图片
        getPhotoList_oldSystem(key,data){
          let imgList = [];
          for (const obj of data) {
              let tempObj={
                    show_name:"(旧系统)"+obj.fileName,
                    type_2:key,
                    img:this.imgBaseUrl + obj.fileAddress
                  }
                  imgList.push(tempObj);
              // imgList.push(this.imgBaseUrl + obj.fileAddress);
            }
         
          console.log("imgList==",imgList) 
          this.saveImage(key,imgList)
        },
//新系统获取图片
        getPhotoList_newSystem(key,data){
          let imgList = [];
          zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key}).then((res)=>{
           if(res.data!=null&&res.data.list.length>0){
            res.data.list.forEach((i)=>{
              let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
              // imgList.push("http://localhost:8080/xjby/view/"+i.show_path);
            })
           }
           this.saveImage(key,imgList)
          })
          
        }, 
        
        // 存放照片
        saveImage(key,data){
      
          if(key==="房屋原貌"){ this.fwImgList=data }
          // if(key==="客厅照片"){ this.ktImgList=data }
          // else if(key==="卧室照片"){ this.wsImgList=data }
          // else if(key==="厨房照片"){ this.cfImgList=data }
          // else if(key==="卫生间照片"){ this.wsjImgList=data }
          // else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data;  }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="付款凭证"){ this.sjfjpzList=data } 
        },
        getImage(key){
          if(key==="房屋原貌"){return this.fwImgList ;}
          // else if(key==="卧室照片"){ return this.wsImgList ; }
          // else if(key==="厨房照片"){ return this.cfImgList ; }
          // else if(key==="卫生间照片"){ return this.wsjImgList ; }
          // else if(key==="其他照片"){ return this.qtImgList ; }

          else if(key==="房屋托管合同信息"){ return this.fwtghtImgList ;  }
          else if(key==="产证信息"){  return this.czImgList ; }
          else if(key==="身份证信息"){ return this.sfzImgList ;  }
          else if(key==="授权委托书"){ return this.sqhtsImgList ;  } 
          else{
            return [];
          }
        },
         // 房屋文件上传
      async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        

        try { 
          let obj = {
          save_name: response.data.saveName,
          save_path: response.data.savePath,
          show_name: response.data.showName,
          show_path: response.data.showPath,
          suffix: response.data.suffix,
          type_1:name,
          type_2:imageType?imageType:null,
          bz:"new_system", 
          father_table:"1_房源",
          father_id:this.houseDetail.id
        };
        let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" +  response.data.saveName, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          zfglMethod_2_001.insertFileRecord(obj).then((res)=>{
            if (name === "产证信息") {
              // this.czImgList.push(obj);
              this.cleanPhotoList("产证信息")
            }
            else if(name === "身份证信息") {
              // this.sfzImgList.push(obj);
              this.cleanPhotoList("身份证信息")
            }
            else if(name === "房屋托管合同信息") {
              // this.fwtghtImgList.push(obj);
              this.cleanPhotoList("房屋托管合同信息")
            }
            else if(name === "房屋原貌") {
              this.cleanPhotoList("房屋原貌")
              // this.fwImgList.push(obj);
              // this.cleanPhotoList_fw("客厅照片")
              // this.cleanPhotoList_fw("卧室照片")
              // this.cleanPhotoList_fw("厨房照片")
              // this.cleanPhotoList_fw("卫生间照片")
              // this.cleanPhotoList_fw("其他照片")

            }
            else if(name === "授权委托书") {
              // this.sqhtsImgList.push(obj);
              this.cleanPhotoList("授权委托书")
            }
            else if(name === "shfjList") {
              this.shfjList.push(obj); 
            }
            else{
              
            }
          })
  
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
      // 其他附件上传
      async uploadSuccess(response, file, fileList,father_id,father_table, type_1,type_2,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name); 
        try { 
          let obj = {
          save_name: response.data.saveName,
          save_path: response.data.savePath,
          show_name: response.data.showName,
          show_path: response.data.showPath,
          suffix: response.data.suffix,
          type_1:type_1,
          type_2:type_2,
          bz:"new_system", 
          father_table:father_table,
          father_id:father_id
        };
        let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" +  response.data.saveName, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          zfglMethod_2_001.insertFileRecord(obj).then((res)=>{
            this.cleanPhotoListV2(type_1)
          })
  
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
          // 在线预览文件
          watchFile(row,name) { 
        utilTools.downloadFromUrl(row.img, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
          utilTools.downloadFromUrl( row.img, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除预上传的附件 
      deleteFileBefore(row,name) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          zfglMethod_2_001.deleteRecord({id:row.id}).then((res)=>{
            if(res.data.deleteRes===1){
              _this.$Message.success("删除成功")
              this.cleanPhotoList(name)
            }
          })

        }
      })
      },
   
      


        getHeight(value) {
          if (value == null) {
            return 50;
          }

        const processedValue = value.toString().replace(/\s+/g, ',');

          const length = processedValue.length; 
          const lines = Math.ceil(length / 28);
          return lines * 50;
        },
        changeZzrq(date){
        this.htzz.zzrq=date
      },
      changeDate(date){ 
            this.sjfk.sjfksj=date 
        },
       
      cancel(){
        this.detailModal=false
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'other_operate_modal_2_005.scss'; 

.base-modal{
        width: 100%;
        height: 700px;
        padding: 20px;
        .illustrate{
          width: 100%;
          height: 50px;
          line-height: 50px;
          display: flex;
          gap:20px;
        }
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }
            .item_3{
                width: 100%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_3-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_3-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            

        }
        .box-1-2{
              width:100%;
              height: 100%;
              display: grid;
              grid-template-columns:50%  50%;
              
            }
    }
  </style>